<template>
  <div :class="{ container: !fullWidth, 'container-home': fullWidth }">
    <div>
      <router-link class="btn btn-primary btn-sm pull-right" :to="`/pages/${item._id}/edit`" v-if="isAdmin && item">
        Edit
      </router-link>
    </div>
    <div v-if="item && item.body" id="page-body" v-html="$embers.markdownIt(item.body)"></div>
    <br>
    <mail-chimp v-if="this.$route.params.page === 'home'"></mail-chimp>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MailChimp from "./_MailChimp";

export default {
  name: "page-public",
  components: {
    MailChimp
  },
  watch: {
    $route: "getData"
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters(["isAuthenticated", "isAdmin"]),
    ...mapState({
      user: state => state.session.user,
      item: state => state.pages.current
    }),
    fullWidth() {
      return this.$route.params.page === "home" && !this.isAuthenticated;
    }
  },
  methods: {
    ...mapActions({
      pagesPublic: "pages/publicRead"
    }),
    async getData() {
      try {
        let route = this.$route.params.page;
        if (route === "home" && this.isAuthenticated) route = "news";

        await this.pagesPublic({ page: route });
        this.$embers.pageData(
          this.item.title,
          this.item.description,
          this.item.keywords
        );
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container-home {
  //margin-top: -42px;
}
</style>
